(function($){
	
	//filter dropdown
	var filterDropdown = function(){
		$('.filter').on('click', function(e){
			e.stopPropagation();
			$(this).toggleClass('active');
			$('.filter').not(this).removeClass('active');
		});
		
		$(document).on('click.closefilter',':not(.filter)', function(){
			$('.filter').removeClass('active');
		});
	};
	
	var headerSearch = function(){
		var searchContainer = $('#site-header');
		
		$('[data-action="header-search"]').on('click', function(e){
			e.preventDefault();
			e.stopPropagation();
			searchContainer.addClass('search-on');
			$('.mega-menu').removeClass('vis');
		});
		
		$('#header-search').find('.inner').on('click', function(e){
			e.stopPropagation();
		});
		
		$(document).on('click.searchclose', function(){
			searchContainer.removeClass('search-on');
		});
	};
	
	var megaMenus = function(){
		var bodyObj = $('body');
		var parentItem = $('#large-nav-primary').find('.menu-item-has-children > a');
		
		parentItem.on('click', function(e){
			e.preventDefault();
			
			var targetMenuId; 
			var targetObj;
			
			var classList = $(this).parent().attr('class').split(/\s+/);
			
			$.each(classList, function(i, el) {
				if (el.indexOf('mega-menu-') > -1) {
					targetMenuId = '#'+el;
					targetObj = $(targetMenuId);
				}
			});
			
			
			if(targetObj.hasClass('vis')){
				targetObj.removeClass('vis');
			}
			else if($('.mega-menu.vis').length > 0){
				if( bodyObj.hasClass('home') && !bodyObj.hasClass('header-stuck')){
					$('body, html').animate({ scrollTop : 0 }, 500);
				}
				$('.mega-menu').not(targetMenuId).removeClass('vis');
				setTimeout(function(){
					targetObj.addClass('vis');
				},300);
			}
			else{
				if( bodyObj.hasClass('home') && !bodyObj.hasClass('header-stuck')){
					$('body, html').animate({ scrollTop : 0 }, 500);
				}
				targetObj.addClass('vis');
			}
		});
		
		$('.mega-menu-close').on('click', function(e){
			e.preventDefault();
			$('.mega-menu').removeClass('vis');
		});
		
		$('.mega-menu, #large-nav-primary').on('click.megaclose', function(e){
			e.stopPropagation();
		});
		
		$(document).on('click', function(){
			$('.mega-menu').removeClass('vis');
		});
	};
	
	/*var portfolioGallery = function(){
		var mainImg = $('#gallery-main-img');
		var fadeHelper = $('#fade-helper');
		
		$('[data-action="portfolio-gallery"]').on('click', function(e){
			e.preventDefault();
			
			var newimg = this.href;
			
			$('html, body').animate({scrollTop : mainImg.offset().top - 60}, 500);
			
			fadeHelper.attr('src', newimg ).addClass('vis');
			setTimeout(function(){
				mainImg.attr('src', newimg );
				fadeHelper.removeClass('vis');
			}, 500);
		});
	};*/
	var portfolioGallery = function(){
		var mainImg = $('#gallery-main');
		var fadeHelper = $('#fade-helper');
		var gallerylist = $('#gallery-list');
		var gallerylistItems = gallerylist.find('li').length;
			//console.log(gallerylistItems);
		
		$('[data-action="portfolio-gallery"]').on('click', function(e){
			e.preventDefault();
			
			var newimg = this.href;
			
			$('[data-action="portfolio-gallery"]').not(this).removeClass('active');
			$(this).addClass('active');
			
			$('html, body').animate({scrollTop : mainImg.offset().top - 90}, 500);
			
			fadeHelper.css('background-image', 'url(' + newimg + ')').addClass('vis');
			setTimeout(function(){
				mainImg.css('background-image', 'url(' + newimg + ')');
				fadeHelper.removeClass('vis');
			}, 500);
		});
		
		$('[data-action="gallery-nav"]').on('click', function(){
			var thisEl = $(this);
			var activeSlide = gallerylist.find('a.active');
			var activeSlideIndex = activeSlide.parent('li').index();
			var nextSlide = activeSlideIndex+1;
			var prevSlide = activeSlideIndex-1;
			var targetslide;
			
			if(thisEl.hasClass('prev')){
				
				if(activeSlideIndex <= 0){
					targetslide = gallerylistItems-1;
				}
				else{
					targetslide = prevSlide;
				}
			}
			if(thisEl.hasClass('next')){
				if(activeSlideIndex >= gallerylistItems-1){
					targetslide = 0;
				}
				else{
					targetslide = nextSlide;
				}
			}
			
			gallerylist.find('li').eq(targetslide).find('[data-action="portfolio-gallery"]').trigger('click');
		});
	};
	
	var homePage = function(){
		
		var $body = $('body');
		var win = $(window);
		var brandTab = document.getElementById('logo-tab');
		//var tabOffset = brandTab.getBoundingClientRect().top;
		var header = $('#site-header');
		var carousel = $('#home-carousel');
		
		win.scroll($.throttle(100, function(){
			//console.log(brandTab.offset().top);
			if(win.scrollTop() >= (header.offset().top - brandTab.getBoundingClientRect().top - 45)){
				$body.addClass('logo-stuck');
			}
			else{
				$body.removeClass('logo-stuck');
			}
			
			if(win.scrollTop() >= carousel.height()){
				$body.addClass('header-stuck');
			}
			else{
				$body.removeClass('header-stuck');
			}
			
		}));
		
		/*$('#large-nav-primary').find('.menu-item-has-children > a').on('click.homescroll', function(){
			
			var targetMenuId; 
			
			var classList = $(this).parent().attr('class').split(/\s+/);
			
			$.each(classList, function(i, el) {
				if (el.indexOf('mega-menu-') > -1) {
					targetMenuId = '#'+el;
				}
			});
			
			if($(targetMenuId).hasClass('vis')){
				$(targetMenuId).removeClass('vis');
			}
			
			if( !$body.hasClass('header-stuck') && !$(targetMenuId).hasClass('vis')){
				$('body, html').animate({ scrollTop : 0 }, 500);
			}
		});*/
		
		
		$('#home-carousel .slick-wrapper').slick({
			autoplay : true,
			autoplaySpeed : 6000,
			pauseOnHover : false,
			cssEase: 'ease-in',
		});
		
		$('[data-action="show-partners"]').on('click', function(e){
			e.preventDefault();
			$('.partners-list.hidden').addClass('show').removeClass('hidden');
			$(this).addClass('hid');
			$('[data-action="hide-partners"]').removeClass('hid');
		});
		
		$('[data-action="hide-partners"]').on('click', function(e){
			e.preventDefault();
			$('.partners-list.show').addClass('hidden').removeClass('show');
			$(this).addClass('hid');
			$('[data-action="show-partners"]').removeClass('hid');
		});
		
		if(document.location.hash){
			var target = document.location.hash;
			$('body,html').animate({
				scrollTop: $(target).offset().top - $('#site-header').height()
			}, 500);
		}
		
	};
	
	var backtotopLink = function(){
		$('.backtotop').find('a').on('click', function(e){
			e.preventDefault();
			var target = this.hash;
			var headerHeight = $('#site-header').outerHeight();
			$('html, body').animate({
				scrollTop : $(target).offset().top - headerHeight
			}, 500);
		});
	};
	
	var solutionSlider = function(){
		if($('.solution-gallery-slider').length > 0){
			$('.solution-gallery-slider').slick({
				autoplay : true,
				autoplaySpeed : 3000,
				pauseOnHover : false,
				dots: false,
				arrows: true,
				nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
				prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>'
			});
		}
	};
	
	var interstitial = function(){
		var allowInterstitialThisSession = (sessionStorage.getItem('interstitial') === null || sessionStorage.getItem('interstitial') === 'on');
		var isInterstitialEnabled = Boolean(MSWObject.interstitial_bool);

		if( allowInterstitialThisSession && isInterstitialEnabled ){
			$('body').addClass('interstitial-open');
			sessionStorage.setItem( 'interstitial', 'off' );
		}
			
		$('.close-interstitial').on('click', function(e){
			e.preventDefault();
			$('body').removeClass('interstitial-open');
			sessionStorage.setItem( 'interstitial', 'off' );
		});
	};

	$(document).ready(function(){
		interstitial();
		filterDropdown();
		megaMenus();
		portfolioGallery();
		headerSearch();
		backtotopLink();
		solutionSlider();
		
		if( $('body').hasClass('home') ){
			homePage();
		}
	});

})(jQuery);

/* jshint ignore:start */

/**
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);

/* jshint ignore:end */